// extracted by mini-css-extract-plugin
export default {"recos":"A5-z","productCardOverride":"B5-z","rowHasBadge":"C5-z"};